import { Fragment, useCallback, useEffect } from "react";
import { HomePageUser } from "./homepageuser";
import AOS from "aos";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { loadFull } from "tsparticles";
import { motion } from "framer-motion";

import Banner from "./static/banners";
import "../styles/bootstrap.min.css";
import "../styles/animate.min.css";
import "../styles/fontawesome.min.css";
import "../styles/homepage.css";
import Partners from "./static/partners";
import Pricing from "./static/pricing";
import Contact from "./static/contact";
import Services from "./static/services";
import Faq from "./static/faq";
import Footer from "./static/footer"; 
import { FederationId } from "../settings"; 
import {
  ChartContainer,
  DonutCharts,
  GeoHeatMap,
} from "../components/dashboards";
import i18next from "i18next";
import { useTranslation } from "react-i18next"; 

export const HomePage = (props) => {
  const navigate = useNavigate();
  const animation = props.animation;
  const currentTheme = useSelector((state) => state.currentTheme);
  const appearance = useSelector((state) => state.appearance);
  const currentUser = useSelector((state) => state.currentUser);

  const { t } = useTranslation();

  const particlesInit = useCallback(async (engine) => {
    //console.log(engine);
    // you can initiate the tsParticles instance (engine) here, adding custom shapes or presets
    // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
    // starting from v2 you can add only the features you need reducing the bundle size
    await loadFull(engine);
  }, []);

  const particlesLoaded = useCallback(async (container) => {
    //await console.log(container);
  }, []);

  const reportsMenu = [
    {
      Id: 1,
      Title: t("homepage.logio"),
      Icon: "cancel",
      OrderId: 1,
      IsExpanded: false,
      Items: [
        { Id: 51, Title: "Report #1", OrderId: 1 },
        { Id: 52, Title: "Report #2", OrderId: 2 },
        { Id: 53, Title: "Report #3", OrderId: 3 },
      ],
    },
    {
      Id: 2,
      Title: t("homepage.marketing"),
      Icon: "edit",
      OrderId: 2,
      IsExpanded: false,
      Items: [
        { Id: 61, Title: "Report #10", OrderId: 1 },
        { Id: 62, Title: "Report #11", OrderId: 2 },
        { Id: 63, Title: "Report #12", OrderId: 3 },
      ],
    },
  ];

  useEffect(() => {
    AOS.init();
    if (FederationId && FederationId !== "" && !currentUser && !currentUser.IsAuthenticated) {
      navigate("/login", { replace: true });
    }
  }, []);

  const ScrollToHash = () => {
    const { hash } = useLocation();

    useEffect(() => {
      if (hash) {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }
    }, [hash]);

    return null;
  };

  return (
    <Fragment>
      <motion.div
        id={"homePage"}
        initial={animation.initial || undefined}
        animate={animation.animate || undefined}
        exit={animation.exit || undefined}
        transition={animation.transition || undefined}
      >
        <div className="home-page" style={{ width: "100%", height: "100%" }}>
          {(!currentUser || !currentUser.IsAuthenticated) && (
            <>
              <ScrollToHash />
              <Banner />
              <Services />
              {FederationId == "" && <Pricing />}
              <Faq />
              <Partners />
              <Contact />
              <Footer />
            </>
          )}
          {
            <>
              {currentUser && currentUser.IsAuthenticated && (
                <HomePageUser
                  currentTheme={currentTheme}
                  currentUser={currentUser}
                />
              )}
            </>
          }
          {
            <Fragment>
              {/* //     {(!currentUser || !currentUser.IsAuthenticated) &&
            //     <Particles
            //         id="tsparticles"
            //         init={particlesInit}
            //         loaded={particlesLoaded}
            //         options={{
            //             fullScreen:{enable: false, zIndex: -1},
            //             background: {
            //                 //image: "linear-gradient(to right, #002D54, #002240) !important",
            //                 color: {
            //                     value: currentTheme.appBarHomeBg,//"0078d4",//"#0d47a1",
            //                 },
            //             },
            //             fpsLimit: 40,
            //             interactivity: {
            //                 events: {
            //                     onClick: {
            //                         enable: true,
            //                         mode: "push",
            //                     },
            //                     onHover: {
            //                         enable: true,
            //                         mode: "repulse",
            //                     },
            //                     resize: true,
            //                 },
            //                 modes: {
            //                     push: {
            //                         quantity: 4,
            //                     },
            //                     repulse: {
            //                         distance: 200,
            //                         duration: 0.4,
            //                     },
            //                 },
            //             },
            //             particles: {
            //                 color: {
            //                     value: currentTheme.particlesColor,//"#ffffff",
            //                 },
            //                 links: {
            //                     color: currentTheme.particlesColor,//"#ffffff",
            //                     distance: 150,
            //                     enable: true,
            //                     opacity: 0.5,
            //                     width: 1,
            //                 },
            //                 collisions: {
            //                     enable: true,
            //                 },
            //                 move: {
            //                     directions: "none",
            //                     enable: true,
            //                     outModes: {
            //                         default: "bounce",
            //                     },
            //                     random: false,
            //                     speed: 1,
            //                     straight: false,
            //                 },
            //                 number: {
            //                     density: {
            //                         enable: true,
            //                         area: 800,
            //                     },
            //                     value: 90,
            //                 },
            //                 opacity: {
            //                     value: 0.5,
            //                 },
            //                 shape: {
            //                     type: "triangle",
            //                 },
            //                 size: {
            //                     value: { min: 1, max: 5 },
            //                 },
            //             },
            //             detectRetina: true,
            //         }}
            //     />
            //     }
            //     <div className="layer-outer">
            //         <div className="layer-inner">
            //         </div>
            //     </div>
            //     {(!currentUser || !currentUser.IsAuthenticated) &&
            //     <img style={{zIndex: 2, position: "absolute", top: 100, left: "8%", width: 600, height: 551}} src="./homeimage.png"/>
            //     }
            //     {(!currentUser || !currentUser.IsAuthenticated) &&
            //     <div style={{
            //         zIndex:2,
            //         position: "absolute",
            //         top: 180, left:"calc(8% + 670px)",
            //         color: "#fff",
            //         fontSize: 18, fontWeight: 400, fontFamily: "poppins, sans-serif",
            //         display: "flex", flexDirection: "column", alignItems: "flex-start"
            //     }}
            //     >
            //         <div style={{width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center"}}>
            //             <div style={{width: 20, height: 20, borderLeft: `6px solid ${currentTheme.particlesColor}`, borderTop: `6px solid ${currentTheme.particlesColor}`}}/>
            //             <div style={{width: 20, height: 20, borderRight: `6px solid ${currentTheme.particlesColor}`, borderTop: `6px solid ${currentTheme.particlesColor}`}}/>
            //         </div>
            //         <div style={{padding: "2px 36px 30px 36px", display: "flex", flexDirection: "column", alignItems: "flex-start"}}>
            //             <div style={{marginTop:14, alignSelf: "center", fontSize: 56, fontWeight: 700, fontStyle: "normal"}}>Intelligence</div>
            //             <div style={{marginTop:4, alignSelf: "center", fontSize: 18, fontWeight: 700, fontStyle: "italic"}}>Value Added Services - Business Intelligence</div>
            //             <div style={{marginTop:28, fontStyle: "italic"}}>A Cross Browser, Secure and Easy To Implement System </div>
            //             <div style={{marginTop:14, fontStyle: "italic"}}>Custom Alerts with flexible rules and conditions</div>
            //             <div style={{marginTop:14, fontStyle: "italic"}}>Triggers through push notifications and API calls</div>
            //             <div style={{marginTop:14, fontStyle: "italic"}}>A Flexible and Robust Reporting and Analytics Engine</div>
            //             <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", marginTop: 32}}>
            //                 <div className="custom-button">Get Started</div>
            //                 <div className="custom-button">Documentation</div>
            //             </div>
            //         </div>
            //         <div style={{width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center"}}>
            //             <div style={{width: 20, height: 20, borderLeft: `6px solid ${currentTheme.particlesColor}`, borderBottom: `6px solid ${currentTheme.particlesColor}`}}/>
            //             <div style={{width: 20, height: 20, borderRight: `6px solid ${currentTheme.particlesColor}`, borderBottom: `6px solid ${currentTheme.particlesColor}`}}/>
            //         </div>
            //     </div>
            //     }
            //     {/* <div className="footer">
            //         <div className="footer-wrapper">
            //             <div className="item">About Us</div>
            //             <div className="item">Community</div>
            //             <div className="item">Knowledge Base</div>
            //             <div className="item">What's New</div>
            //         </div>
            //     </div> */}
            </Fragment>
          }
          {/* {
                        currentUser && currentUser.IsAuthenticated &&
                        <HomePageUser currentTheme={currentTheme} currentUser={currentUser} />
                    } */}
        </div>
      </motion.div>
      <style>
        {`
                        #homePage
                        {
                            width: 100%;
                            height: 100%; 
                             direction: ${
                              appearance.isRightToLeft ? "rtl" : "ltr"
                            }  
                        }

                        .home-page .layer-outer
                        {
                            position: absolute;
                            zIndex: 3;    
                            top: 100px;
                            left: 0;
                            width: 100%;
                            height: 100%;
                            background-image: linear-gradient(to top, #0d42b2 0%, #0d42b2 5%, rgba(0, 0, 0, 0) 40%, rgba(0, 0, 0, 0) 100%);
                            }

                        .home-page .layer-inner
                        {
                            background-image: linear-gradient(15deg, #5286D1 0%, #436EAB 5%, transparent 50%, transparent 100%) !important;
                            width: 100%;
                            height: 100%;
                            top: 0;
                            left: 0;
                        }

                         #tsparticles
                         {
                            position: fixed;
                            height: 100%;
                            width: 100%;
                            overflow: hidden;
                         }

                         .custom-button
                         {
                            padding: 12px 18px;
                            font-size: 16px;
                            font-weight: 700;
                            border: 2px solid #fff;
                            border-radius: 8px;
                            color: ${currentTheme.particlesColor};
                         }

                         .footer
                         {
                            position: absolute;
                            bottom: 0px;
                            left: 0;
                            width: 100%;                            
                            color: ${currentTheme.touchColor};     
                            display: flex;
                            justify-content: center;
                            align-items: center;    
                            zIndex: 2;                   
                         }

                         .footer-wrapper
                         {                           
                            flex:1;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            padding: 12px;       
                            /*background-image: ${currentTheme.footerBgImage};*/
                         }

                         .footer .item
                         {
                            padding: 0 22px;
                            font-size: 14px;
                            font-weight:700;
                            color: ${currentTheme.particlesColor};
                         }
                         
                    `}
      </style>
    </Fragment>
  );
};

//export const HomePage = {Component: Home};
